import { styled } from '@mui/system';

export const LoaderStyled = styled('div')({
  width: '100%',
  minHeight: '50vh',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
